import { render, staticRenderFns } from "./GoalForm.vue?vue&type=template&id=e46207e6&scoped=true"
import script from "./GoalForm.vue?vue&type=script&lang=js"
export * from "./GoalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e46207e6",
  null
  
)

export default component.exports